// redux/slices/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { projectReducer } from "../Reducer/projectReducer";

const initialState = {
    loading: false,
    projects: [],
    error: null,
    isProjectUpdated: true,

};
const projectSlice = createSlice({
    name: "project",
    initialState,
    reducers: {
        setProjectSliceToInitial:(state)=>{
            state={
                loading: false,
                projects: [],
                error: null,
                isProjectUpdated: true,
            
            }
        }
    },
    extraReducers: (builder) => {
        projectReducer(builder);
    },
});

export const {setProjectSliceToInitial } = projectSlice.actions;
export default projectSlice.reducer;
